import CryptoJS from 'crypto-js';

var iv = process.env.REACT_APP_IV;
iv = CryptoJS.enc.Utf8.parse(iv);


export const encryptData = (data, key, custom) => {
  let secretkey = ''
  if (custom) {
    iv = CryptoJS.enc.Utf8.parse(custom?.iv);
    secretkey = CryptoJS.enc.Utf8.parse(custom?.secret_key);
    return CryptoJS.AES.encrypt(data, secretkey, { iv: iv }).toString();
  } 
  if (key === "user_auth") {
    secretkey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AUTH_SECRET_KEY);
    return CryptoJS.AES.encrypt(data, secretkey, { iv: iv }).toString();
  } else {
    secretkey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY);
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretkey, { iv: iv })?.toString();
  }
};


export const decryptData = (ciphertext, key, custom) => {
  let secret = ''
  if (custom) {
    iv = CryptoJS.enc.Utf8.parse(custom?.iv);
    secret = CryptoJS.enc.Utf8.parse(custom?.secret_key);
  } else if (key === "user_auth") {
    secret = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AUTH_SECRET_KEY)
  } else {
    secret = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY)
  }
  if (ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(ciphertext, secret, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      try {
        const decryption = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        if (decryption) {
          return decryption;
        }
      } catch {
        return decryptedData;
      }
    } catch (error) {
      console.error("error in encryption and decryption", error);
    }
  }
};